import { cn } from '@magicdoorinc/ui';
import { Show } from 'solid-js';
import { leasePeriodString } from '~/components/leases/utils';
import type { Component } from 'solid-js';
import type { HydratedLeaseDto, LeaseDto } from '~/swagger/portal/Api';

type LeasePeriodProps = {
  class?: string;
  lease?: HydratedLeaseDto | LeaseDto;
};

export const LeasePeriod: Component<LeasePeriodProps> = (props) => {
  return (
    <Show when={props.lease}>
      <div class={cn('whitespace-nowrap text-xs text-text-02', props.class)}>{leasePeriodString(props.lease as HydratedLeaseDto)}</div>
    </Show>
  );
};
